// Package imports:
import React from 'react';
import cx from 'classnames';

type LabelTypes = 'origin' | 'disclaimer' | 'delay' | 'closed' | 'beta';

interface IProps {
    text: string,
    fullText?: string,
    labelType: LabelTypes
};

const Label: React.FC<IProps> = ({
    text,
    fullText,
    labelType
}) => {
    return (
        <div className={cx('KCL_label', `${labelType}-label`)}>
            <span>
                {text}
            </span>

            <span className="full-text">
                {fullText ?? text}
            </span>
        </div>
    );
}

export default Label;